import {
  PrefilledMedicineAttributes,
  PrescriptionTemplateDetail,
} from "@interfaces";

export function toPrefilledTreatmentAttributes(
  detail: PrescriptionTemplateDetail,
): PrefilledMedicineAttributes {
  return {
    ...detail,
    medicineQuantity: detail.quantity ? Number(detail.quantity) : null,
  };
}
